import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import pptxgen from "pptxgenjs";

import budjet from '../../assets/images/PPTXimage/Budget.png';
import duree from '../../assets/images/PPTXimage/Duree.png';
import equipe from '../../assets/images/PPTXimage/Equipe.png';
import filiale from '../../assets/images/PPTXimage/Filiale.png';
import lieu from '../../assets/images/PPTXimage/Lieu.png';
import outils from '../../assets/images/PPTXimage/Outils.png';
import imgXML from "../../assets/images/PPTXimage/Header.png";

import { extractProject} from '../../actions/project';






pptxgen.prototype.addLeftField = function(slide,field){
	slide.addImage({ path: field["image"], w:0.53728, h:0.53728, x:0.288, y:field["offset"],  });
	slide.addText(field["header"], {
		x: 0.93,
		y: field["offset"] - 0.22,
		w: "20%",
		h: 0.5,
		align: "left",
		color: "ADD8E6",
		bold: "true",
		//fill: "F1F1F1",
		fontSize: 14,
	});

	slide.addText( field["value"]  , {
		shape: this.ShapeType.rect,
		x: 0.93,
		y: field["offset"]+ 0.15,
		w: "20%",
		h: 0.4,
		align: "left",
		color: "000000",
		bold: "true",
		line: {width: "2", color:"000000" },
		fontSize: 14,
	});

}


pptxgen.prototype.getProjectDuration = function  getProjectDuration(projectContent){
	let start = JSON.stringify( projectContent.information["start-date"] );
	let end = JSON.stringify( projectContent.information["end-date"] );
	let mois = (parseInt(end[4] + end[5]) - parseInt(start[4] + start[5]));
	let annee = (parseInt(end[7]  + end[8] + end[9] + end[10]) - parseInt(start[7] + start[8] + start[9] + start[10]));

	if (annee === 0) {
	  return( " mois " + mois );
	} 
	if (mois === 0) {
	  return( " année " + annee );
	}
	else {
	  return( " année " + annee + " mois " + mois );
	}
  }

pptxgen.prototype.addLeftColumn =  function addLeftColumn(slide,projectContent,pptx,translate){

	

	if (projectContent.client.picture64){
		slide.addImage({ 
			data: projectContent.client.picture64, 		  
			x: 0.95,
			y: 1.1,
			w: 2.4,
			h: 1, });
	  } else{
		slide.addShape( pptx.ShapeType.rect, {
			x: 0.95,
			y: 1.1,
			w: 2.4,
			h: 1,
			line: {width: "2", color:"000000" },
		  });
	  }

	slide.addShape( this.ShapeType.rect, {
		x: 0.95,
		y: 1.1,
		w: 2.4,
		h: 1,
		line: {width: "2", color:"000000" },

	});


	const fields = [{"image" : duree , "offset" : 2.28 , "header" : translate("content.information.duration.title") , "value" : this.getProjectDuration(projectContent) + '\n' + projectContent.information["start-date"] + ' - ' + projectContent.information["end-date"]},
					{"image" : budjet , "offset" : 3.15 , "header" : translate("content.information.budget.title") , "value" : projectContent.information["budget"]},
					{"image" : lieu , "offset" : 4.02 , "header" : translate("content.client.localisation-client-country.title") , "value" : projectContent.information["filiale-country"] + " - " + projectContent.information.office},
					{"image" : equipe , "offset" : 4.89 , "header" : translate("content.information.staff.title") , "value" : ''},
					{"image" : filiale , "offset" : 5.76 , "header" : translate("content.filiale.title") , "value" : projectContent.client.client},
					{"image" : outils , "offset" : 6.63 , "header" : translate("content.tools.title") , "value" : projectContent.tools.join(', ')},
	]

	fields.forEach((field,idx) => this.addLeftField(slide,field))

}

pptxgen.prototype.addBodyField =  function addBodyField(slide,field){

	slide.addText(field["header"], {
		shape: this.ShapeType.rect,
		x: 3.69,
		y: field["offset"] - 0.22,
		w: "20%",
		h: 0.3,
		align: "left",
		color: "FFFFFF",
		fill: "5B9BD5",
		fontSize: 14,
	});

	slide.addText( field["value"]  , {
		shape: this.ShapeType.rect,
		x: 3.7,
		y: field["offset"]+ 0.08,
		w: field["w"],
		h: field["h"],
		align: "left",
		color: "ADD8E6",
		line: {width: "2", color:"5B9BD5" },
		fontSize: 9,
		valign: 'top'
	});


}

class  ExtractorExtern extends React.Component {

    constructor(props){
      super(props);
      this.state = {
        waiting : false,
        timestamp : null,
        consultant : null
      }
	  
    }

	

	handleClick(){
		this.props.extractProject(this.props.projects._id);
		this.createPPTX()
	
	  }




    createPPTXSlideIovision(pptx,projectContent,product){

	  var slide = pptx.addSlide()

      slide.addImage({ path: imgXML, w:12, x:0, y:0 });

      slide.addText(product.content.information.name, {
	        x: 2.5,
        	y: 0,
	        w: "100%",
	        h: 1,
	        align: "left",
	        color: "FFFFFF",
	        //fill: "F1F1F1",
	        fontSize: 20,
        });

	  
	  pptx.addLeftColumn(slide,projectContent,pptx,this.props.translate)

	  const objective_field = {"header" : this.props.translate("content.notes.objectives.title") , "value" : product.content.notes.objectives , "offset" : 1.3, "w":5, "h" : 0.8}
	  pptx.addBodyField(slide,objective_field)

	  const context_field = {"header" : this.props.translate("content.notes.process.title") , "value" : product.content.notes.process , "offset" : 2.8, "w":5, "h" : 1.2}
	  pptx.addBodyField(slide,context_field)

	  const activity_field = {"header" : this.props.translate("content.notes.results.title") , "value" : product.content.notes.results , "offset" : 4.7, "w":8, "h" : 2.4}
	  pptx.addBodyField(slide,activity_field)

	  if (projectContent.picture64){
		slide.addImage({ 
			data: projectContent.picture64, 		  
			x: 9,
			y: 1.1,
			w: 2.7,
			h: 3.5, });
	  } else{
		slide.addShape( pptx.ShapeType.rect, {
			x: 9,
			y: 1.1,
			w: 2.7,
			h: 3.5,
			line: {width: "2", color:"000000" },
	
		  });
	  }
    }


    createPPTXSlide(pptx,project){

		var slide = pptx.addSlide()
  
		slide.addImage({ path: imgXML, w:12, x:0, y:0 });
  
		slide.addText(project.content.information.name, {
			  x: 2.5,
			  y: 0,
			  w: "100%",
			  h: 1,
			  align: "left",
			  color: "FFFFFF",
			  //fill: "F1F1F1",
			  fontSize: 20,
		  });
  
		
		pptx.addLeftColumn(slide,project.content,pptx,this.props.translate)
  
		const objective_field = {"header" : this.props.translate("content.notes.objectives.title") , "value" : project.content.notes.objectives , "offset" : 1.3, "w":5, "h" : 0.8}
		pptx.addBodyField(slide,objective_field)
  
		const context_field = {"header" : this.props.translate("content.notes.implementation.title") , "value" : project.content.notes.context , "offset" : 2.8, "w":5, "h" : 1.2}
		pptx.addBodyField(slide,context_field)
  
		const activity_field = {"header" : this.props.translate("content.notes.results.title") , "value" : project.content.notes.activity , "offset" : 4.7, "w":8, "h" : 2.4}
		pptx.addBodyField(slide,activity_field)
  
		if (project.picture64){
			slide.addImage({ 
				data: project.picture64, 		  
				x: 9,
				y: 1.1,
				w: 2.7,
				h: 3.5, });
		  } else{
			slide.addShape( pptx.ShapeType.rect, {
				x: 9,
				y: 1.1,
				w: 2.7,
				h: 3.5,
				line: {width: "2", color:"000000" },
			  });
		  }
	  }

    createPPTX(){

      
      let pptx = new pptxgen();
      // Define new layout for the Presentation
      pptx.defineLayout({ name:'A3', width:12, height:7.5 });

      // Set presentation to use new layout
      pptx.layout = 'A3'

	//   project is either an array or a single project (js object)


	  if (Array.isArray(this.props.projects)){
		this.props.projects.forEach((project, idx) => {
			this.createPPTXSlide(pptx,project)
		  });
	  }
	  else {
		this.createPPTXSlide(pptx,this.props.projects)
	  }
	
      pptx.writeFile({ fileName: "IKOS - PptxGenJS - Demonstrator" });

    }



    render(){

    
        return (
		<button className={this.props.className} style={this.props.style} onClick={this.handleClick.bind(this)} >   {this.props.title}    </button>

        )
      }
  
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => bindActionCreators({
  extractProject
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps, null)(ExtractorExtern);